import React from 'react';
import { Avatar } from '@material-ui/core';
import { useStyles } from './styles';
import Button from '@material-ui/core/Button';

const DivStatusChanged = ({ user, openDetails, exchange }) => {
  const classes = useStyles();

  return (
    <div>
      <Button
        type="button"
        onClick={() => {
          openDetails(exchange, user);
        }}
        style={{
          padding: 0,
        }}
      >
        <Avatar className={classes.avatarConfirm} src={user?.image} />
      </Button>
    </div>
  );
};

export default DivStatusChanged;
